import React, { useState, useRef, useEffect, useId } from 'react';
import IconInfo from '../icons/IconInfo';

function Tooltip({ ariaLabel = 'More info', className, children }) {
    const [isTooltipVisible, setTooltipVisible] = useState(false);
    const [isTouchMode, setIsTouchMode] = useState(false);
    const tooltipId = useId();
    const containerRef = useRef(null);
    const hideTimeout = useRef(null);

    useEffect(() => {
        const onPointerDown = (e) => {
            if (e.pointerType === 'touch') {
                setIsTouchMode(true);
            }
        };
        window.addEventListener('pointerdown', onPointerDown);
        return () => {
            window.removeEventListener('pointerdown', onPointerDown);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                isTooltipVisible &&
                containerRef.current &&
                !containerRef.current.contains(event.target)
            ) {
                setTooltipVisible(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isTooltipVisible]);

    const showTooltip = () => {
        clearTimeout(hideTimeout.current);
        setTooltipVisible(true);
    };

    const hideTooltip = () => {
        hideTimeout.current = setTimeout(() => {
            setTooltipVisible(false);
        }, 150);
    };

    const cancelHide = () => {
        clearTimeout(hideTimeout.current);
    };

    const toggleTooltip = () => {
        clearTimeout(hideTimeout.current);
        setTooltipVisible((prev) => !prev);
    };

    const handleClick = (e) => {
        if (isTouchMode) {
            e.preventDefault();
            toggleTooltip();
        }
    };

    return (
        <div className={`fireknife-tooltip ${className ?? ''}`} ref={containerRef}>
            <button
                className="fireknife-tooltip__btn"
                type="button"
                onClick={handleClick}
                onMouseEnter={!isTouchMode ? showTooltip : undefined}
                onMouseLeave={!isTouchMode ? hideTooltip : undefined}
                onFocus={!isTouchMode ? showTooltip : undefined}
                onBlur={!isTouchMode ? hideTooltip : undefined}
                aria-describedby={tooltipId}
                aria-label={ariaLabel}
                aria-expanded={isTooltipVisible}
                aria-controls={tooltipId}
            >
                <IconInfo className="fireknife-tooltip__btn-icon" />
            </button>

            <div
                className={`fireknife-tooltip__content ${
                    isTooltipVisible ? 'fireknife-tooltip__content--is-visible' : ''
                }`}
                id={tooltipId}
                role="tooltip"
                onMouseEnter={!isTouchMode ? cancelHide : undefined}
                onMouseLeave={!isTouchMode ? hideTooltip : undefined}
            >
                {children}
            </div>
        </div>
    );
}

export default Tooltip;
